'use client';

import { Link2 } from 'lucide-react';

interface CrmConnectCompleteModalProps {
  onFinish: () => void;
}

export function CrmConnectCompleteModal({ onFinish }: CrmConnectCompleteModalProps) {
  return (
    <div
      className="fixed inset-0 z-[300] flex items-center justify-center"
      role="dialog"
      aria-modal="true"
      aria-label="CRM connection tour complete"
    >
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/50" />

      {/* Modal card */}
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-lg w-full mx-4 p-8">
        {/* Icon */}
        <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-accent-blue/[0.08]">
          <Link2 className="h-8 w-8 text-accent-blue" />
        </div>

        {/* Title */}
        <h2 className="text-2xl font-bold mb-4 text-center text-gray-900">
          You&rsquo;re Almost Connected
        </h2>

        {/* Content */}
        <div className="text-left space-y-4 mb-8">
          <p className="text-base leading-relaxed text-gray-500">
            Once you&rsquo;ve saved your Zapier credentials, <strong className="text-gray-700">Voley
            will connect your Agency Zoom account within 24 hours</strong>. You&rsquo;ll
            receive a notification when the integration is live and ready to use.
          </p>
          <div className="bg-blue-50 rounded-lg p-4 space-y-2">
            <p className="text-sm text-blue-800">
              <strong className="text-blue-900">Important:</strong> Make sure to remove any
              existing SMS automation from your Agency Zoom workflow. If you don&rsquo;t,
              clients may receive <strong>duplicate text messages</strong> &mdash; one from
              Agency Zoom&rsquo;s automation and one from Voley.
            </p>
          </div>
          <p className="text-sm leading-relaxed text-gray-500">
            After the connection is active, all new leads and contact updates will flow
            seamlessly between Agency Zoom and Voley using your single agency phone number.
          </p>
        </div>

        {/* Finish button */}
        <div className="flex justify-center">
          <button
            onClick={onFinish}
            aria-label="Finish tour"
            className="inline-flex items-center justify-center gap-2 px-8 py-3 rounded-full text-base font-semibold text-white bg-accent-blue hover:brightness-110 transition-all shadow-md"
          >
            Finish Tour
          </button>
        </div>
      </div>
    </div>
  );
}
